import React, { useState, useEffect } from "react";
import { Checkbox } from "@fluentui/react-components";

const CheckboxInput = (props) => {
  const { label, checked, setChecked, checkStatus, isMilestone , StyleClass, disabled } = props;


  return (
    <Checkbox
      className={`${StyleClass} checkboxWrapper ${disabled && 'disabled'}`}
      // id="checkbox"
      checked={checked}
      disabled={disabled}
      // checked={isChecked || checkStatus}
      onChange={(ev, data) => setChecked(data.checked)}
      // onChange={(ev, data) => setChecked(data.checked)}
      label={label}
    />
  );
};

export default CheckboxInput;
